import { ReactNode } from 'react';
import RefreshButton from './RefreshButton';
import LoginButton from './LoginButton';
import NotificationBell from './NotificationBell';
import GlobalSearch from './GlobalSearch';

interface Props {
  title: string;
  subtitle?: ReactNode;
  right?: ReactNode;
  hideRefresh?: boolean;
}

export default function PageHeader({ title, subtitle, right, hideRefresh }: Props) {
  return (
    <header className="mb-4 lg:mb-6 px-4 lg:px-0 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="font-display text-2xl lg:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <div className="text-sm text-dim mt-1">{subtitle}</div>}
      </div>
      <div className="shrink-0 flex items-center gap-2">
        {right}
        <GlobalSearch />
        {!hideRefresh && <RefreshButton />}
        <NotificationBell />
        <LoginButton />
      </div>
    </header>
  );
}
